const SECONDS_IN_MS = 1000;
export const DEFAULT_SUCCESS_DURATION = 6 * SECONDS_IN_MS;
export const DEFAULT_ERROR_DURATION = 10 * SECONDS_IN_MS;
